
    <ng-select
      [items]="items"
      [multiple]="false"
      bindLabel="name"
      placeholder="Ort auswählen..."
      [closeOnSelect]="true"
      [(ngModel)]="selectedItem"
      appendTo="body"
      [clearable]="true"
      [disabled]="isDisabled"
      #select
    >
    </ng-select>
  